import React from "react"
import btn_facebook from "../../images/bottom_images/btn_facebook.png"
import btn_linkedin from "../../images/bottom_images/btn_linkedin.png"
import btn_instagram from "../../images/bottom_images/btn_instagram.png"
import btn_twitter from "../../images/bottom_images/btn_twitter.png"
import Here4TN_archive from "../../images/bottom_images/Here4TN_archive.png"
import Optum_Here4TN from "../../images/bottom_images/Optum_Here4TN.png"

export default (props)=>{


    return (<div style={{marginTop:10,backgroundColor:"#434448",paddingBottom:15}} className="container-fluid">
            <div className="container">
    <div  className="row">
            <div className="mt-md-2 col-md-6 text-md-left text-left col-sm-12">
                    <img style={{width:350}} src={Optum_Here4TN}/>
                    
            </div>    
            <div className="mt-4 mt-md-3 col-md-3 col-sm-12 text-center text-md-right pr-4">
                    
                      <a target="_blank" href="https://www.linkedin.com/company/tn-partners-for-health/">
                        <img style={{width:40,marginRight:"-12px",paddingBottom:"20px"}} src={btn_linkedin}/>
               </a>      
            </div>
                     

    </div></div></div>);
}